import firebase from 'firebase'

const firebaseApp = firebase.initializeApp({
  databaseURL: 'https://ray-yafi-portfolio.firebaseio.com',
  storageBucket: 'ray-yafi-portfolio.appspot.com'
})

const db = firebaseApp.database()

const storage = firebaseApp.storage()

export { db, storage }
